<script>
import {mapState} from 'vuex'

import { validateAndSubmit } from '../../../mixins/validateAndSubmit';
import { validationClass } from '../../../mixins/validationClass';

export default {
    data() {
        return {
            activity_name: '',
            form: {
            },
            totals: null,
            disableOnSubmit : false,
            dictionary: {
                en: {
                    attributes: {

                    }
                },
            }
        }
    },

    props: ['url', 'getUrl'],

    mixins: [validateAndSubmit, validationClass],

    computed: {
        showActualErrorMessage: function() {
            var showError = false;
            if (this.totals) {
                for (const key in this.totals.actual) {
                    if (this.totals.actual.hasOwnProperty(key)) {
                        const element = this.totals.actual[key];
                        if (element != 24) {
                            showError = true;
                        } 
                    }
                }
            }
            return showError;
        },
        showIdealErrorMessage: function() {
            var showError = false;
            if (this.totals) {
                for (const key in this.totals.ideal) {
                    if (this.totals.ideal.hasOwnProperty(key)) {
                        const element = this.totals.ideal[key];
                        if (element != 24) {
                            showError = true;
                        } 
                    }
                }
            }
            return showError;
        },
        excessTotalActual: function () {
            if (this.totals == null)
                return true;

            return this.totals.actual.mon > 24 || this.totals.actual.tue > 24 || this.totals.actual.wed > 24 || this.totals.actual.thu > 24 ||
                    this.totals.actual.fri > 24 || this.totals.actual.sat > 24 || this.totals.actual.sun > 24;
        },

        excessTotalIdeal: function () {
            if (this.totals == null)
                return true;

            return this.totals.ideal.mon > 24 || this.totals.ideal.tue > 24 || this.totals.ideal.wed > 24 || this.totals.ideal.thu > 24 ||
                    this.totals.ideal.fri > 24 || this.totals.ideal.sat > 24 || this.totals.ideal.sun > 24;
        },

        ideal_total : function () {
            if (this.totals == null) {
                return 0;
            }            

            var ideal = this.totals.ideal;

            return parseInt(ideal.mon) + parseInt(ideal.tue) + parseInt(ideal.wed) + parseInt(ideal.thu) + parseInt(ideal.fri) + parseInt(ideal.sat) + parseInt(ideal.sun);
        },
        actual_total : function () {
            if (this.totals == null) {
                return 0;
            }

            var actual = this.totals.actual;

            return actual.mon + actual.tue + actual.wed + actual.thu + actual.fri + actual.sat + actual.sun;
        },

    },

    created() {
    },

    mounted() {
        this.resetTotals();
        this.getData();
        this.$validator.localize(this.dictionary);
        var self = this;
        setInterval(() => {
            self.calculateTotals();
        }, 1000);
    },

    watch: {
    },

    methods: {
        getData() {
            axios
                .get(this.getUrl,
                    {
                        params: {
                        }
                    }
                )
                .then(response => {
                    this.form = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        addToActual() {
            if (this.form.actual === null) {
                this.form.actual = {};
            }
            this.form.actual[this.activity_name] =  this.addActivity(this.form.actual);
            this.activity_name = '';
            this.$forceUpdate();
        },
        addToIdeal() {
            if (this.form.ideal === null) {
                this.form.ideal = {};
            }
            this.form.ideal[this.activity_name] = this.addActivity(this.form.ideal);
            this.activity_name = '';
            this.$forceUpdate();
        },
        addToBoth() {
            if (this.form.actual === null) {
                this.form.actual = {};
            }
            if (this.form.ideal === null) {
                this.form.ideal = {};
            }
            this.form.actual[this.activity_name] = this.addActivity(this.form.actual);
            this.form.ideal[this.activity_name] = this.addActivity(this.form.ideal);
            this.activity_name = '';
            this.$forceUpdate();
        },
        addActivity(obj) {
            return obj[this.activity_name] = {
                mon: 0,
                tue: 0,
                wed: 0,
                thu: 0,
                fri: 0,
                sat: 0,
                sun: 0
            }
        },
        removeFromActual(index) {
            delete this.form.actual[index];
            this.$forceUpdate();
        },
        removeFromIdeal(index) {
            delete this.form.ideal[index];
            this.$forceUpdate();
        },
        calculateTotals() {
            this.resetTotals();
            if (this.form.actual != null) {
                for (const key in this.form.actual) {
                    if (this.form.actual.hasOwnProperty(key)) {
                        const element = this.form.actual[key];
                        this.totals.actual.mon += Number(element.mon);
                        this.totals.actual.tue += Number(element.tue);
                        this.totals.actual.wed += Number(element.wed);
                        this.totals.actual.thu += Number(element.thu);
                        this.totals.actual.fri += Number(element.fri);
                        this.totals.actual.sat += Number(element.sat);
                        this.totals.actual.sun += Number(element.sun);
                    }
                }
            }
            if (this.form.ideal != null) {
                for (const key in this.form.ideal) {
                    if (this.form.ideal.hasOwnProperty(key)) {
                        const element = this.form.ideal[key];
                        this.totals.ideal.mon += Number(element.mon);
                        this.totals.ideal.tue += Number(element.tue);
                        this.totals.ideal.wed += Number(element.wed);
                        this.totals.ideal.thu += Number(element.thu);
                        this.totals.ideal.fri += Number(element.fri);
                        this.totals.ideal.sat += Number(element.sat);
                        this.totals.ideal.sun += Number(element.sun);
                    }
                }

            }
        },
        resetTotals() {
            this.totals = {
                actual: {
                    mon: 0,
                    tue: 0,
                    wed: 0,
                    thu: 0,
                    fri: 0,
                    sat: 0,
                    sun: 0,
                },
                ideal: {
                    mon: 0,
                    tue: 0,
                    wed: 0,
                    thu: 0,
                    fri: 0,
                    sat: 0,
                    sun: 0,
                },
            }
        }
    },
}
</script>
